import React from "react";

import "./style.css";

import { FaWhatsapp } from "react-icons/fa";

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <h2>Precisa de ajuda para encontrar a peça ideal?</h2>
        <p>Nossos especialistas estão prontos para te atender no WhatsApp.</p>
        <a
          href="https://wa.me/5544991419595"
          className="cta-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="cta-icon" />
          Falar com Especialista
        </a>
      </div>
    </section>
  );
};

export default CTASection;
